module.exports = __webpack_public_path__ + "static/media/images.aee81535.svg";